export const RESTAURANT_NAME = 'Tasty Junction';

export const NAVIGATION_LINKS = [
    { id: 'home', label: 'Home', href: '#home' },
    { id: 'menu', label: 'Menu', href: '#menu' },
    { id: 'about', label: 'About Us', href: '#about' },
    { id: 'contact', label: 'Contact', href: '#contact' }
];

export const MENU_DATA = {
  appetizers: {
    title: "APPETIZERS",
    items: [
      { name: "SAMOSA (2 PIECES)", price: "4.45" },
      { name: "FRENCH FRIES", price: "4.45" },
      { name: "ALOO TIKKI CHAAT", price: "9.99" },
      { name: "SAMOSA CHAAT", price: "9.99" },
      { name: "CHEF SPL. AMRITSARI FRIED FISH", price: "14.99" }
    ]
  },
  burgers: {
    title: "BURGERS (IN HOUSE TIKKI)",
    items: [
      { name: "ALOO TIKKI BURGER", price: "7.99" },
      { name: "NOODLE ALOO TIKKI BURGER", price: "9.99" },
      { name: "JUMBO ALOO TIKKI BURGER", price: "10.99" },
      { name: "CRISPY CHICKEN BURGER", price: "10.99" },
    ]
  },
  tandooriParatha: {
    title: "TANDOORI PARATHA",
    items: [
      { name: "ALOO PARATHA (2 PIECES)", price: "10.99" },
      { name: "ALOO PYAAZ PARATHA (2 PIECES)", price: "11.99" },
      { name: "PANEER PARATHA (2 PIECES)", price: "12.99" },
      {name: "Served with Yogurt, Butter, and Pickle", price: "0"}
    ]
  },
  pasta: {
    title: "PASTA",
    items: [
      { name: "WHITE SAUCE VEG PASTA", price: "13.99" },
      { name: "WHITE SAUCE CHICKEN PASTA", price: "14.99" },
      { name: "INDIAN TWIST VEG PASTA", price: "14.99" },
      { name: "INDIAN TWIST CHICKEN PASTA", price: "15.99" }
    ]
  },
  hakka: {
    title: "HAKKA SECTION",
    items: [
      { name: "CHILLI POTATO", price: "9.99" },
      { name: "VEG MANCHURIAN (GRAVY + $1)", price: "13.99" },
      { name: "VEG HAKKA NOODLES", price: "12.99" },
      { name: "CHICKEN HAKKA NOODLES", price: "14.99" },
      { name: "CHILLI SOYA CHAAP", price: "15.99" },
      { name: "TJ SPL. CHILLI PANEER", price: "16.99" },
      { name: "CHILLI CHICKEN", price: "17.99" },
      { name: "TJ SPL. CHICKEN 65", price: "17.99" },
    ]
  },
  wraps: {
    title: "WRAPS/ROLLS (W/ Fries)",
    items: [
      { name: "DESI TIKKI NOODLE WRAP", price: "12.99" },
      { name: "TANDOORI PANEER TIKKA WRAP", price: "13.99" },
      { name: "TANDOORI SOYA CHAAP WRAP", price: "13.99" },
      { name: "SPL. TANDOORI CHICKEN TIKKA WRAP", price: "14.99" },
    ]
  },
  chaaps: {
    title: "CHAAPS",
    items: [
      { name: "TANDOORI SOYA CHAAP", price: "16.99" },
      { name: "CHILLI SOYA CHAAP", price: "15.99" },
      { name: "CHEF SPL. MALAI SOYA CHAAP", price: "16.99" },
      { name: "KADHAI CHAAP", price: "17.99" }
    ]
  },

  tandoorSe: {
    title: "TANDOORI TIKKA (INDIAN STYLE)",
    items: [
      { name: "PANEER TIKKA", price: "16.99" },
      { name: "MALAI PANEER TIKKA", price: "17.99" },
      { name: "SPL. CHICKEN TIKKA", price: "18.99" },
      { name: "MALAI CHICKEN TIKKA", price: "18.99" }
    ]
  },

  riceBiryani: {
    title: "RICE & BIRYANI",
    items: [
      { name: "ZEERA RICE", price: "4.99" },
       { name: "VEG FRIED RICE", price: "12.99" },
      { name: "CHICKEN FRIED RICE", price: "14.99" },
      { name: "VEG BIRYANI", price: "14.99" },
      { name: "CHICKEN BIRYANI (BONELESS)", price: "16.99" }
    ]
  },
  lunchCombos: {
    title: "COMBOS",
    items: [
      { name: "CHHOLE BHATURE", price: "13.99" },
      { name: "SPL. AMRITSARI KULCHA WITH CHHOLE", price: "13.99" },
      { name: "PANEER-ONION KULCHA WITH CHHOLE", price: "14.99" },
      { name: "VEG COMBO (1 VEG CURRY, NAAN, RICE AND POP)", price: "17.99" },
      { name: "NON-VEG COMBO (1 NON-VEG CURRY, NAAN, RICE AND POP)", price: "18.99" }
    ]
  },

  vegCurries: {
    title: "VEG CURRIES",
    items: [
      { name: "DAL TADKA", price: "15.99" },
      { name: "DAL MAKHANI", price: "16.99" },
      { name: "CHANA MASALA", price: "16.99" },
      { name: "PANEER TIKKA MASALA", price: "17.99" },
      { name: "KADHAI PANEER", price: "17.99" },
      { name: "KADHAI CHAAP", price: "17.99" },
      { name: "CHEF SPL. MALAI METHI PANEER", price: "18.99" },
    ]
  },
  nonVegCurries: {
    title: "NON-VEG CURRIES",
    items: [
      { name: "BUTTER CHICKEN", price: "18.99" },
      { name: "CHICKEN TIKKA MASALA", price: "18.99" },
      { name: "KADHAI CHICKEN", price: "18.99" },
      { name: "CHICKEN CURRY", price: "18.99" },
      { name: "MALAI METHI CHICKEN", price: "18.99" }
    ]
  },
  
  breads: {
    title: "BREADS",
    items: [
      { name: "TANDOORI ROTI", price: "2.99" },
      { name: "PLAIN NAAN",    price: "2.99" },
      { name: "BUTTER NAAN",   price: "3.49" },
      { name: "GARLIC NAAN", price: "3.99" },
      { name: "BULLET NAAN", price: "3.99" },
      { name: "LACHHA PARATHA", price: "4.99" },
      { name: "SPL. PANEER ONION KULCHA", price: "9.99" }
    ]
  },
  drinks: {
    title: "DRINKS",
    items: [
      { name: "SODA POP", price: "2.49" },
      { name: "INDIAN SODA POP", price: "2.99" },
      { name: "MASALA CHAI", price: "3.49" },
      { name: "LASSI (SALTY OR SWEET)", price: "4.99" },
      { name: "TJ SPL. MINT LIME SODA", price: "4.99" },
      { name: "MANGO LASSI", price: "5.99" },
      { name: "MANGO MILKSHAKE", price: "6.99" },
    ]
  },
  chutneys: {
    title: "CHUTNEYS",
    items: [
      { name: "MINT CHUTNEY", price: "0.99" },
      { name: "TAMARIND CHUTNEY", price: "0.99" }
    ]
  },
  

  extras: {
    title: "EXTRAS",
    items: [
      { name: "PICKLED ONIONS", price: "1.99" },
      { name: "PLAIN YOGURT", price: "2.99" },
      { name: "CUCUMBER RAITA", price: "4.99" },
      { name: "GREEN SALAD BOWL", price: "6.99" }
    ]
  },

  dessert: {
    title: "DESSERT",
    items: [
      { name: "GULAB JAMUN (2 PIECES)", price: "4.99" },
      { name: "GULAB JAMUN ON ICE-CREAM", price: "4.99" },
      { name: "CHEF SPL. BADAM KHEER", price: "6.99" }
    ]
  }
};

export const HOME_DATA = {
    hero: {
        welcome: "Welcome to ",
        title: "Tasty Junction<br/>Indian Eatery",
        subtitle: "Authentic Taste with a Modern Twist!",
        cta: "View Menu",
        offers: "Offers"
    }
};

export const ABOUT_DATA = {
    title: "About Tasty Junction",
    content: ["Welcome to Tasty Junction – Authentic Taste, Modern Twist. Our journey began with a passion for authentic Indian flavors and a commitment to using only quality ingredients. Our chef brings over a decade of experience in crafting dishes that celebrate the rich culinary traditions of India while adding a fresh, modern touch. From sizzling tandoori specialties to flavorful curries and refreshing desserts, every dish is made with care and love. We take pride in serving authentic Indian delicacies in a warm and welcoming atmosphere — where every bite delivers the perfect balance of tradition and innovation."
    ],
    image: "./logo.png"
};

export const CONTACT_DATA = {
    title: "Contact Us",
    info: {
        phone: "(613) 228 0303",
        email: "tastyjunctioneatery@gmail.com",
        address: "1950 Merivale Rd, Ottawa, ON K2G5T5"
    },
    hours: {
        title: "Opening Hours",
        weekdays: "Monday & Wednesday - Thursday: 12:00 PM - 12:00 AM (MIDNIGHT)",
        weekends: "Friday - Saturday: 12:00 PM (NOON) - 2:00 AM",
        sunday: "Sunday: 2 PM - 11 PM",
        closed: "Closed: Tuesday"
    },
    form: {
        fields: [
            { type: "text", placeholder: "Your Name", required: true },
            { type: "email", placeholder: "Your Email", required: true },
            { type: "tel", placeholder: "Your Phone", required: true },
            { type: "textarea", placeholder: "Your Message", required: true }
        ],
        submitText: "Send Message"
    }
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1585937421612-70a008356fbe?auto=format&fit=crop&w=1920&q=80",
    about: "https://drive.google.com/drive/u/2/my-drive"
};
